import { AxiosRequestConfig, AxiosResponse } from 'axios'
import HttpClient from '../http-client'
import { httpConfig } from '../constants'
import {
  ContextModel,
  ContextModelPost,
  DescriptiveCharacteristicPost,
  GapExtended,
  IndependentCharacteristicPost,
} from '../model/models'

export class ContextModelAPI extends HttpClient {
  public constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig)
    this.saveContextModels = this.saveContextModels.bind(this)
    this.saveIndependentCharacteristicsForContextModel =
      this.saveIndependentCharacteristicsForContextModel.bind(this)
    this.saveDescriptiveCharacteristicsForContextModel =
      this.saveDescriptiveCharacteristicsForContextModel.bind(this)
  }

  public saveContextModels(contextModels: ContextModelPost[]): Promise<number> {
    const endpoint = `/context-models/`
    return this.post(endpoint, contextModels)
      .then((response: AxiosResponse) => response.status)
      .catch((error) => {
        throw error
      })
  }

  public saveIndependentCharacteristicsForContextModel(
    contextModel: ContextModel,
    independentCharacteristics: IndependentCharacteristicPost[],
  ): Promise<void> {
    const endpoint = `/context-models/${contextModel.id}/independent-characteristics`
    return this.put(endpoint, independentCharacteristics)
      .then(() => {})
      .catch((error) => {
        throw error
      })
  }

  public saveIndependentCharacteristicsConstantForContextModel(): Promise<number> {
    const endpoint = `/context-models/independent-characteristics/add-constant`
    return this.post(endpoint, {})
      .then((response: AxiosResponse) => response.status)
      .catch((error) => {
        throw error
      })
  }

  public getContextModels(): Promise<ContextModel[]> {
    const endpoint = `/context-models/`
    return this.get<ContextModel[]>(endpoint)
      .then((response: AxiosResponse<ContextModel[]>) => response.data)
      .catch((error) => {
        throw error
      })
  }

  public saveDescriptiveCharacteristicsForContextModel(
    contextModel: ContextModel,
    descriptiveCharacteristicPosts: DescriptiveCharacteristicPost[],
  ) {
    const endpoint = `/context-models/${contextModel.id}/descriptive-characteristics`
    return this.put(endpoint, descriptiveCharacteristicPosts)
      .then(() => {})
      .catch((error) => {
        throw error
      })
  }

  public getContextVariantsInfo(
    moduleId: number,
    date: Date,
  ): Promise<Record<string, GapExtended>> {
    return this.get<Record<string, GapExtended>>(`gap-result-descriptions/${moduleId}`, {
      params: {
        date_of_execution: date,
      },
    })
      .then((response: AxiosResponse<Record<string, GapExtended>>) => response.data)
      .catch((error) => {
        throw error
      })
  }
}

export const contextModelAPI = new ContextModelAPI(httpConfig)
